var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperSkinActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.859,
    height: 37.859,
    viewBox: "0 0 37.859 37.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-183.636 -64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(171 64)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.636 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.929,
    cy: 18.929,
    r: 18.929,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.356,
    cy: 17.356,
    r: 17.356,
    transform: "translate(1.573 1.573)",
    fill: "#a64daa"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.18 72.908)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.099)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.554,85.522a.5.5,0,0,1-.18-.034c-.337-.13-3.31-1.317-3.852-2.791a1.546,1.546,0,0,1,.3-1.73,4.07,4.07,0,0,1,1.287-.776,5.943,5.943,0,0,0,.668-.331c.553-.348.84-.688.806-.955a1.952,1.952,0,0,0-.292-.635,2.5,2.5,0,0,1-.428-1.1v-.005a1.48,1.48,0,0,1,.117-.657c-.018-.017-.043-.037-.074-.062a.5.5,0,0,1-.1-.676.926.926,0,0,0,.094-.163c-.031-.039-.088-.1-.133-.143a3.469,3.469,0,0,1-.357-.413.729.729,0,0,1-.048-.813,1.646,1.646,0,0,1,.588-.536,2.281,2.281,0,0,0,.2-.135l.02-.032c-.036-.117-.36-.353-.484-.442-.056-.041-.109-.079-.156-.115-.17-.132-.357-.262-.555-.4A6.762,6.762,0,0,1,52.6,71.434a2.439,2.439,0,0,1-.428-1.067,2.321,2.321,0,0,0-.185-.6,7.8,7.8,0,0,0-1.526-1.94,6.116,6.116,0,0,0-.866-.662,5.307,5.307,0,0,0-2.359-.832.5.5,0,1,1,.1-1,6.294,6.294,0,0,1,2.8.983,7.1,7.1,0,0,1,1,.767,8.8,8.8,0,0,1,1.723,2.188,3.115,3.115,0,0,1,.29.875,1.7,1.7,0,0,0,.223.647,6.068,6.068,0,0,0,1.172.962c.2.139.4.282.593.428.039.03.085.063.133.1.372.27,1.148.832.825,1.63l-.005.013a1.4,1.4,0,0,1-.114.2,1.543,1.543,0,0,1-.48.413c-.039.025-.09.058-.137.091.042.046.085.09.127.133a1.03,1.03,0,0,1,.35,1.2.844.844,0,0,1,.087.9.524.524,0,0,0-.055.243,1.759,1.759,0,0,0,.289.651,2.715,2.715,0,0,1,.424,1.017c.088.7-.339,1.348-1.269,1.933a6.732,6.732,0,0,1-.789.4c-1.086.487-1.265.7-1.061,1.246.293.8,2.164,1.775,3.275,2.2a.5.5,0,0,1-.181.966Z",
    transform: "translate(-47.282 -65.836)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M56.342,90.011h-.028c-.3-.017-7.476-.453-9.377-3.781a4.1,4.1,0,0,1,.173-4.089l.066-.128c1.993-3.853,2.9-5.611.268-9.3a.5.5,0,1,1,.814-.581c1.411,1.975,1.959,3.6,1.778,5.282a15.243,15.243,0,0,1-1.972,5.058L48,82.6a3.132,3.132,0,0,0-.193,3.134c.661,1.158,2.335,2.092,4.84,2.7a23.312,23.312,0,0,0,3.724.578.5.5,0,0,1-.027,1Z",
    transform: "translate(-46.972 -70.325)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.729,19.266a.5.5,0,0,1-.116-.014A13.992,13.992,0,0,1,4.539,17.4,10.7,10.7,0,0,1-.378,9.921,9.388,9.388,0,0,1,1.992,1.914a10.444,10.444,0,0,1,3.2-2.373A.5.5,0,0,1,5.846-.2a.5.5,0,0,1-.261.657A9.628,9.628,0,0,0,2.7,2.62,8.335,8.335,0,0,0,.612,9.776a9.269,9.269,0,0,0,1.7,4.176,10.818,10.818,0,0,0,2.784,2.61A13.147,13.147,0,0,0,8.844,18.28a.5.5,0,0,1-.115.987Z",
    transform: "matrix(0.996, 0.087, -0.087, 0.996, 193.045, 73.33)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperSkinActiveIcon);
export default __webpack_public_path__ + "static/media/swiper_skin_active_icon.2ca9e9e8.svg";
export { ForwardRef as ReactComponent };